// tslint:disable: quotemark
export enum SiteBusinessDaysStatusEnum {
	BusinessDaysSet = 0,
	BusinessDaysNotSet = 1,
	SitesClosed = 2,
	All = 3
}

export namespace SiteBusinessDaysStatusEnum {
	export function toDescription(val: SiteBusinessDaysStatusEnum) {
		switch (val) {
			case 0:
				return "Business Days Set";
			case 1:
				return "Business Days Not Set";
			case 2:
				return "Sites Closed";
			case 3:
				return "All";
		}
		return null;
	}
}
